import { render, staticRenderFns } from "./ChanpinFenlei.vue?vue&type=template&id=6e787ad7&scoped=true&"
import script from "./ChanpinFenlei.vue?vue&type=script&lang=js&"
export * from "./ChanpinFenlei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e787ad7",
  null
  
)

export default component.exports